import {
	ArrayMinSize,
	IsArray,
	IsBoolean,
	IsDateString,
	IsIn,
	IsInt,
	IsOptional,
	IsString,
	IsUUID,
	Min,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export const STATS_BLOCK_KEYS = [
	'tradeCount',
	'pnl',
	'winRate',
	'bestTrade',
	'lobbyRank',
	'sportBreakdown',
] as const;

export type StatsBlockKey = (typeof STATS_BLOCK_KEYS)[number];

export class CampaignDateRangeDto {
	@IsDateString()
	start: string;

	@IsDateString()
	end: string;
}

export class CampaignScopeDto {
	@IsArray()
	@ArrayMinSize(1)
	@IsUUID('4', { each: true })
	lobbyIds: string[];

	@ValidateNested()
	@Type(() => CampaignDateRangeDto)
	dateRange: CampaignDateRangeDto;
}

export class CampaignAudienceDto {
	@IsInt()
	@Min(0)
	minTradesInScope: number;
}

export class CampaignLobbyRankConfigDto {
	@IsBoolean()
	amongTraders: boolean;
}

export class CampaignConfigDto {
	@ValidateNested()
	@Type(() => CampaignScopeDto)
	scope: CampaignScopeDto;

	@ValidateNested()
	@Type(() => CampaignAudienceDto)
	audience: CampaignAudienceDto;

	@IsArray()
	@ArrayMinSize(1)
	@IsString({ each: true })
	@IsIn(STATS_BLOCK_KEYS, { each: true })
	statsBlocks: StatsBlockKey[];

	@IsOptional()
	@ValidateNested()
	@Type(() => CampaignLobbyRankConfigDto)
	lobbyRankConfig?: CampaignLobbyRankConfigDto;
}

export class CreateCampaignDto {
	@IsString()
	name: string;

	@IsString()
	subject: string;

	@IsOptional()
	@IsString()
	intro_text?: string;

	@ValidateNested()
	@Type(() => CampaignConfigDto)
	config: CampaignConfigDto;
}

export class UpdateCampaignDto {
	@IsOptional()
	@IsString()
	name?: string;

	@IsOptional()
	@IsString()
	subject?: string;

	@IsOptional()
	@IsString()
	intro_text?: string;

	@IsOptional()
	@ValidateNested()
	@Type(() => CampaignConfigDto)
	config?: CampaignConfigDto;
}

export class CampaignPreviewDto {
	@IsOptional()
	@IsUUID()
	userId?: string; // defaults to the admin's own id
}

export class CampaignTestSendDto {
	@IsUUID()
	userId: string;
}
